import {CA} from './analytics/Analytics'
import {PatchNoteData} from './patch_notes/PatchNoteData'
import {StorageWrapper} from './StorageWrapper'
import {ViewPopupPatchNotes} from './ui_popup/ViewPopupPatchNotes'

export class UIVersionController {
    static patchNoteRemoveAction: () => void = () => undefined

    private readonly thisVersion: number
    private readonly getStorageVersion: () => number | null
    private readonly updateStorageVersion: (no: number) => void
    willShowPatchnoteThisSession: boolean

    constructor(getStorageVersion: () => number | null, thisVersion: number, updateStorageVersion: (no: number) => void) {
        this.getStorageVersion = getStorageVersion
        this.thisVersion = thisVersion
        this.updateStorageVersion = updateStorageVersion
        this.willShowPatchnoteThisSession = false
        if(this.hasNoVersion()) {
            CA.sendGoogleAnalyticsEvent(CA.Category.Funnel, CA.Label.FunnelNewUserEnteredSite)
            this.setVersion()
        }
    }

    private setVersion() {
        this.updateStorageVersion(this.thisVersion)
    }

    // refresh() {
    //     location.reload(true)
    // }

    isSameVersion(): boolean {
        if(this.getStorageVersion() == null) return false
        return this.getStorageVersion() == this.thisVersion
    }

    private hasNoVersion(): boolean {
        const storageVersion = this.getStorageVersion()
        return storageVersion == 0 || storageVersion == null
    }

    showPatchnotes() {
        if(this.isSameVersion()) return
        this.willShowPatchnoteThisSession = true
        this.setVersion()
        StorageWrapper.setCareersNotificationBadgeVisible(true)
        const pnData = new PatchNoteData()
        CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.GeneralShowingPatchNotePopup)
        const popup = new ViewPopupPatchNotes(pnData.getLast5(), pnData.getAnnouncements(), UIVersionController.patchNoteRemoveAction)
    }
}
